import UpcomingEventCard from './UpcomingEventCard';

export default UpcomingEventCard;